import { isBugBountyParticipant } from '@atlassian/amkt-common';
import { CloudFortifiedStatusValues } from '@atlassian/mpac-types';
import { AtlassianProductHostingType } from '@atlassian/mpac-types/graphql-gateway-types';
export const isAppCloudSecurityParticipant = app => {
  var _app$programs;
  return isBugBountyParticipant(AtlassianProductHostingType.Cloud, app === null || app === void 0 ? void 0 : (_app$programs = app.programs) === null || _app$programs === void 0 ? void 0 : _app$programs.bugBountyParticipant) && app.deployments.includes('cloud');
};
export const isAppCloudFortified = app => {
  var _app$programs2, _app$programs2$cloudF;
  return ((_app$programs2 = app.programs) === null || _app$programs2 === void 0 ? void 0 : (_app$programs2$cloudF = _app$programs2.cloudFortified) === null || _app$programs2$cloudF === void 0 ? void 0 : _app$programs2$cloudF.status) === CloudFortifiedStatusValues.Approved;
};

// TODO https://ecosystem.atlassian.net/browse/FMI-550
export const isEcosystemCloudApp = tile => tile.version.cloud && tile.version.cloud.cloudAppId;
export const certificationBadgeResolver = enableCloudFortifiedAppsDiscovery => {
  const hasCloudFortifiedBadge = app => enableCloudFortifiedAppsDiscovery && isAppCloudFortified(app);
  const hasCloudSecurityBadge = app => !hasCloudFortifiedBadge(app) && isAppCloudSecurityParticipant(app);
  return {
    hasCloudFortifiedBadge,
    hasCloudSecurityBadge
  };
};